<top-banner variant="title" title="Training Course"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div *ngIf="course" class="row animated fadeIn">
          <!-- side menu -->
          <div class="col-md-2 cardtabs-wrapper">
            <nav class="nav cardtabs flex-column">
              <div class="back-and-menu-link">
                <a [routerLink]="['/', routeRole, 'training']" class="nav-link back-link">all courses</a>
              </div>
            </nav>
          </div>

          <!-- main area -->
          <div class="col-md-10">
            <div class="card-body mb-2">
              <h4 class="card-title">{{ course.trainingName }}</h4>

              <dl class="sideways-dl">
                <div>
                  <dt>Type</dt>
                  <dd>{{ course.type }}</dd>
                </div>
                <div>
                  <dt>Name</dt>
                  <dd>{{ course.trainingName }}</dd>
                </div>
                <div>
                  <dt>Description</dt>
                  <dd>{{ course.description }}</dd>
                </div>
                <div>
                  <dt>Valid For (Months)</dt>
                  <dd>{{ course.validForMonths }}</dd>
                </div>
              </dl>

              <a class="btn btn-primary btn-link" [routerLink]="['/', routeRole, 'training', trainingId, 'edit']">edit</a>
              <a class="btn btn-danger btn-link" (click)="deleteInductionTraining()">delete</a>
              <a *ngIf="course.type === 'OUTAGE_ACCEPTANCE'" class="btn btn-success btn-round float-right" [routerLink]="['/', routeRole, 'training', trainingId, 'contractors']">see contractors/report</a>
              <br />
              <br />

              <div *ngIf="course.type === 'INDUCTION'">
                <b>Currently induction on {{ course.sites.length }} {{ 'site' | plural : course.sites.length }}:</b>&nbsp;
                <span>{{ course.sites.join(', ') }}</span>
              </div>

              <br />
              <br />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <ng-container *ngFor="let section of course.sections; let i = index">
                    <div class="edit-training_section-bar">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="col-md-2" *ngIf="section.sectionType === TrainingSectionType.Video"><i class="fa fa-video"></i></div>
                        <div class="col-md-2" *ngIf="section.sectionType === TrainingSectionType.Pdf"><i class="fa fa-file-pdf"></i></div>
                        <div class="col-md-2" *ngIf="section.sectionType === TrainingSectionType.Question"><i class="fa fa-tasks"></i></div>

                        <div class="col-md-6">Section {{ i + 1 }}: {{ section.sectionName }}</div>

                        <div class="col-md-4" *ngIf="section.sectionType === TrainingSectionType.Pdf">
                          <a href="javascript:void(0)" (click)="openFile(section.documentUrl)">
                            {{section.documentUrl}}
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                        </div>

                        <div class="col-md-4" *ngIf="section.sectionType === TrainingSectionType.Video">
                            <a href="javascript:void(0)" (click)="openVideo(section.videoUri)">
                              {{section.videoUri.replace('https://skylark-video-assets.s3.eu-west-2.amazonaws.com/', '')}}
                              <i class="fas fa-external-link-alt"></i>
                            </a>
                        </div>

                        <div class="col-md-4" *ngIf="section.sectionType === TrainingSectionType.Question">
                            {{section.questions.length}} {{'question' | plural: section.questions.length}}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
